import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

// Dynamic manifest: use admin manifest for /admin routes
if (window.location.pathname.startsWith('/admin')) {
  const link = document.querySelector('link[rel="manifest"]');
  if (link) link.href = '/manifest-admin.json';
}
